export const QUERY_KEY_DEVICE_ACTIVITY = 'device-activity'